(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/content/image-v2/assets/javascripts/image.js') >= 0) return;  svs.modules.push('/components/content/image-v2/assets/javascripts/image.js');
'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _React = React,
  useState = _React.useState,
  useEffect = _React.useEffect;
const clsvs = svs.utils.clsvs;
const _Handlebars$helpers = Handlebars.helpers,
  getDefaultImgUrl = _Handlebars$helpers.getDefaultImgUrl,
  getNoscriptUrl = _Handlebars$helpers.getNoscriptUrl,
  getSourceElementsData = _Handlebars$helpers.getSourceElementsData,
  getUrlWithCorrectHost = _Handlebars$helpers.getUrlWithCorrectHost,
  getImageProminentColor = _Handlebars$helpers.getImageProminentColor,
  isOriginalImage = _Handlebars$helpers.isOriginalImage;
const config = {
  options: svs.core.config.data.svsconfig
};
const logger = new svs.core.log.Logger('image-v2:React_Image');
const Image = _ref => {
  let image = _ref.image,
    cssSelectors = _ref.cssSelectors,
    onLoadCallback = _ref.onLoadCallback,
    fallbackImage = _ref.fallbackImage;
  const _ref2 = image || {},
    altText = _ref2.altText,
    aspectRatio = _ref2.aspectRatio,
    fitWrapper = _ref2.fitWrapper,
    loadingLazy = _ref2.loadingLazy,
    noscriptUrl = _ref2.noscriptUrl,
    sizes = _ref2.sizes,
    title = _ref2.title,
    height = _ref2.height,
    width = _ref2.width;
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    hasError = _useState2[0],
    setHasError = _useState2[1];
  const fallbackImageUrl = getUrlWithCorrectHost(fallbackImage, config);
  const sourceElements = getSourceElementsData(image);
  const noScriptUrl = getNoscriptUrl(image, undefined, noscriptUrl, false);
  const defaultImgUrl = getDefaultImgUrl(image, undefined, undefined, false);
  const imageClassName = clsvs('image-wrapper', fitWrapper && 'background-image-wrapper image-wrapper-fit', cssSelectors);

  useEffect(() => {
    setHasError(false);
  }, [noScriptUrl]);
  const prominentColor = getImageProminentColor(image);
  const imageStyle = {
    backgroundColor: prominentColor
  };
  const imageType = 'http://schema.org/ImageObject';
  const handleError = ev => {
    const currentTarget = ev.currentTarget;
    currentTarget.onerror = null;
    if (fallbackImage) {
      setHasError(true);
    } else {
      logger.warn("Failed to load image: ".concat(currentTarget.currentSrc));
    }
  };
  const useOriginalImage = isOriginalImage(image) || (image === null || image === void 0 ? void 0 : image.originalImage);
  const Img = () => {
    const ImgSrc = hasError ? fallbackImageUrl : useOriginalImage ? noScriptUrl : defaultImgUrl;
    return React.createElement("img", {
      alt: altText || title || '',
      className: "js-image image",
      "data-fallback-image": hasError,
      decoding: "sync",
      height: (aspectRatio === null || aspectRatio === void 0 ? void 0 : aspectRatio.height) || height,
      itemProp: "image",
      loading: loadingLazy ? 'lazy' : 'eager',
      onError: handleError,
      onLoad: onLoadCallback,
      sizes: sizes || '100vw',
      src: ImgSrc,
      title: title || null,
      width: (aspectRatio === null || aspectRatio === void 0 ? void 0 : aspectRatio.width) || width
    });
  };
  return React.createElement("div", {
    className: imageClassName,
    "data-is-react": true,
    itemScope: true,
    itemType: imageType,
    style: imageStyle
  }, React.createElement("meta", {
    content: hasError ? fallbackImageUrl : noScriptUrl,
    itemProp: "url"
  }), useOriginalImage || hasError ? React.createElement(Img, null) : React.createElement("picture", null, sourceElements.map(source => React.createElement("source", {
    key: source.id,
    media: source.media,
    sizes: source.sizes,
    srcSet: source.srcSet
  })), React.createElement(Img, null)));
};
svs.content.image_v2.Image = Image;

 })(window);